import React from "react";

export const RoboshooterIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9975 6.11383H11.3481V6.88613H12.9975V6.11383Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.20068 6.11378H6.11333V4.20111C5.13683 4.36463 4.3642 5.13726 4.20068 6.11378Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.87939 4.2012V6.11387H8.79204C8.62852 5.13738 7.85589 4.36474 6.87939 4.2012Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.20361 6.88617C4.3671 7.86266 5.13976 8.63532 6.11626 8.79884V6.88617H4.20361Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.87939 6.88608V8.79875C7.85589 8.63526 8.62855 7.8626 8.79204 6.88608H6.87939Z"
        fill="#C6B7FF"
      />
      <path d="M6.89291 0H6.12061V1.64939H6.89291V0Z" fill="#C6B7FF" />
      <path d="M6.89291 11.3506H6.12061V13H6.89291V11.3506Z" fill="#C6B7FF" />
      <path d="M1.64939 6.11383H0V6.88613H1.64939V6.11383Z" fill="#C6B7FF" />
      <path
        d="M6.87939 1.64975V3.42069C8.28245 3.5956 9.3976 4.71078 9.57254 6.11384H11.3435C11.156 3.73822 9.25498 1.83716 6.87939 1.64975Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.65186 6.11381H3.42279C3.59771 4.71075 4.71289 3.5956 6.11594 3.42066V1.64975C3.74033 1.83716 1.83926 3.73822 1.65186 6.11381Z"
        fill="#C6B7FF"
      />
      <path
        d="M3.42279 6.88608H1.65186C1.83926 9.26167 3.74033 11.1627 6.11592 11.3501V9.5792C4.71289 9.40428 3.59771 8.28911 3.42279 6.88608Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.57254 6.88608C9.39763 8.28913 8.28245 9.40428 6.87939 9.57922V11.3502C9.25498 11.1628 11.156 9.26169 11.3435 6.8861L9.57254 6.88608Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};

